import { render } from "./openCloseIcon.vue?vue&type=template&id=3df8e747"
import script from "./openCloseIcon.vue?vue&type=script&lang=js"
export * from "./openCloseIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__